module.exports = __webpack_public_path__ + "img/main_buy.56005448.jpg";